/* MOG MINTS: every sideways belt swipes on a phone (Ashot, 2026-09-30). Since 2026-10-05 the roll on a
   phone is the compositor's, as it always was on the desktop.

   First built for the percentages ("Make the % swipable on mobile. Don't add any indication, but
   people naturally want to swipe it but cant, keep it animated as is but allow people to swipe
   through them or hold them down to stop"), then asked for everywhere: "same for the trust icon row
   at the top below the hero, same for the product section pretty much anytime theres a place where
   something scrolls like that I want it done there."

   A CSS marquee cannot be touched, so under 900px each [data-marquee] track sits in a real scroller
   with no scrollbar and rolls at the CSS belt's own pace: one period per animation-duration. A finger
   down stops it. A swipe takes over with the phone's own momentum and the roll resumes REST ms after
   the last scroll event. It never reaches an end in either direction. Nothing is drawn: no dots, no
   arrows, no hint. Above 900px the CSS animation runs untouched; the clones, the sizer's styles and
   the transform leave with it so the translateX(-50%) and (-25%) keyframes keep travelling one period
   per cycle. Reduced motion keeps whatever the stylesheet gives it, which for the percentages is a
   static wrapped grid.

   WHY THE ROLL LEFT scrollLeft (2026-10-05). Ashot, the day the seals took their ring text: "make the
   icons move smoother, right now it's laggy. It is only laggy on mobile." The 2026-09-30 engine rolled
   the belt by writing scroller.scrollLeft from requestAnimationFrame, and that was the phone's path
   alone. WebKit keeps a scroll offset in whole CSS pixels (written 100.6, it reads back 100), and the
   seal strip travels 920px in 60s, a quarter of a pixel per frame. So it could only move as one whole
   pixel about every fourth frame (measured in WebKit: of 180 frames the seals moved on 46 and stood
   still on 134): fifteen jumps a second, three device pixels each on a phone, which the old marks hid
   and fine ring text does not. Each step was also made on the main thread, so the roll waited whenever
   the page worked there (the mint under the strip runs a frame loop of its own on a phone; in Chrome's
   own compositor frames, with the main thread held for 1.3s the old roll drew nothing for 1.3s and
   this one travelled its 16.8px), and every belt kept a frame loop running for the life of the page
   whether it was on screen or not.

   HOW IT WORKS NOW. Two motions that add up, and neither is ever traded for the other.
     THE ROLL is a transform on the track, run by the compositor (element.animate, the machinery under
     the desktop's CSS keyframes), in pixels over exactly one period. Percent keyframes cannot do it:
     a percentage is a share of the track, and the track holds more copies here than on the desktop.
     THE VISITOR moves the scroller, natively.
   A finger down, or any scroll this file did not make, freezes the roll where the browser says it
   stands: the animation is replaced by a static transform of that value. When the roll takes the belt
   back it starts from that static value. So there is nothing to jump at either end. The scroll offset
   is never written while a finger could be on the belt. The one write is a step of whole periods back
   to the middle of the range just before the roll resumes, and a whole period changes nothing on
   screen, because the content repeats every period.

   WHY THE ROLL'S OFFSET IS NOT HANDED TO scrollLeft WHEN THE FINGER LANDS. That swaps a transform for
   a scroll offset in one frame, on two different inputs of the compositor, at the moment the phone's
   own scroll gesture is starting, and scrollLeft would round it to a whole pixel on the way. Adding
   the two needs no swap.

   THE SIZER. parent > .mq__scroll > .mq__size > track. The track is translated up to two periods to
   the left (up to one standing, one more while it rolls), so its right end moves. .mq__size is a
   clipping box two periods shorter than the track: it gives the scroller one scroll range that the
   transform cannot change, with content under every position in it. Its styles are inline because
   they are measured, and they leave above 900px.

   The parent keeps its fades: they sit on the clipping element, outside the scroller, so they do not
   travel with the content. The animation-duration is read once, before .mq-swipe sets animation:none
   and the computed duration would read 0s. A browser without element.animate keeps the 2026-09-30
   engine, unchanged, at the foot of this file. */
(function () {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var tracks = [].slice.call(document.querySelectorAll('[data-marquee]'));
  if (!tracks.length) return;
  var mq = matchMedia('(max-width: 900px)');

  var REST = 350;     /* ms after the last scroll event before the roll takes the belt back (decision 108) */
  var COPIES = 6;     /* periods of content under 900px. Two are the transform's travel (see THE SIZER); the other
                         four are the scroller's range, the same range the 2026-09-30 engine had */

  if (typeof tracks[0].animate !== 'function') { legacy(tracks, mq); return; }

  var units = tracks.map(function (track) {
    return {
      track: track, parent: track.parentElement, scroller: null, sizer: null, clones: [],
      on: false, seen: true, fed: false, holding: false, settle: 0, rolling: false, anim: null,
      period: 0, view: 0, t: 0, sl: 0,
      /* the real copy is the children not marked aria-hidden; the Liquid marks every copy after the first */
      n: [].filter.call(track.children, function (c) { return !c.hasAttribute('aria-hidden'); }).length || 1,
      secs: parseFloat(getComputedStyle(track).animationDuration) || 30
    };
  });

  function shift(x) { return 'translate3d(' + (Math.round(-x * 1000) / 1000) + 'px,0,0)'; }
  function put(u) { u.track.style.transform = shift(u.t); }
  /* a standing belt sits on a whole device pixel, so the ring text is sharp while it is held */
  function snap(x) { var r = window.devicePixelRatio || 1; return Math.round(x * r) / r; }

  /* Copies are cloned from the Liquid's first hidden copy where there is one: it is already written for a
     copy (alt="", tabindex="-1" on the reels' links), which the real copy is not. */
  function fill(u, copies) {
    var kids = [].slice.call(u.track.children), have = Math.floor(kids.length / u.n);
    var src = have > 1 ? kids.slice(u.n, u.n * 2) : kids.slice(0, u.n);
    for (; have < copies; have++) src.forEach(function (c) {
      var k = c.cloneNode(true); k.setAttribute('aria-hidden', 'true'); u.track.appendChild(k); u.clones.push(k);
    });
  }
  /* One period, in layout pixels: the track's width over its copies, the same sum the desktop's percent
     keyframes do (25% of four copies, 50% of two). The computed width, because it is a layout value. It keeps
     the fraction offsetLeft rounds away: the reels' period is 451.125px, and the keyframes below travel exactly
     this far before they loop, so a rounded period would tick by the remainder once a lap. And unlike a rect it
     is not drawn through an ancestor's transform or sampled from a running animation. Both went wrong with
     rects while this was built (2026-10-05): the page's arrival holds the buy card's children at scale(.995)
     while it waits to play, which read the benefit strip's 1030.3px period as 1025.2px, and two rects taken
     a millisecond apart on a rolling belt read the seals' 920px as 920.015px in WebKit. Layout places boxes on
     64ths of a pixel; rounding to that grid restores what a browser trims off the printed width. */
  function measure(u) {
    u.period = Math.round(parseFloat(getComputedStyle(u.track).width) / Math.floor(u.track.children.length / u.n) * 64) / 64;
    u.view = u.scroller.clientWidth;
  }
  /* Enough copies that the scroller's range is at least one period wider than the belt's window, so a step of
     whole periods always has somewhere to land. Six covers all four belts at every width under 900px. */
  function fit(u) {
    fill(u, Math.max(COPIES, Math.ceil(u.view / u.period) + 3));
    u.sizer.style.overflow = 'hidden'; u.sizer.style.overflow = 'clip';   /* clip where it exists (Safari 16): a clip box cannot be scrolled by a focus */
    u.sizer.style.width = (Math.floor(u.track.children.length / u.n) - 2) * u.period + 'px';
  }
  /* the middle of the range, on a whole period so the first seal starts at the edge as it does on the desktop */
  function home(u) {
    u.scroller.scrollLeft = Math.round((u.scroller.scrollWidth - u.view) / 2 / u.period) * u.period;
    u.sl = u.scroller.scrollLeft; u.t = 0; put(u);
  }
  /* The geometry is measured at the start, again each time the belt comes on screen, and when the window changes
     width. If nothing moved this is two reads and a return. If it did (a turned phone, a belt that was not
     laid out the first time) the scroller goes back to the middle and the track keeps the share of a period the
     picture stood at, so the same seal is still at the edge. */
  function refit(u) {
    var was = u.period, view = u.view, share;
    fill(u, 2); measure(u);
    if (u.period === was && u.view === view) return;
    if (u.rolling) freeze(u);
    if (!(u.period > 0)) return;   /* not laid out (a closed parent): the roll waits until the belt is seen */
    share = was > 0 ? (u.scroller.scrollLeft + u.t) / was % 1 : 0;
    fit(u); home(u);
    u.t = share * u.period; put(u);
  }

  /* Where the track stands, in px to the left, as the browser itself reports it: the computed transform. For a
     track that is not being rendered (a closed parent) both engines compute "none" (measured 2026-10-05), and
     the animation's own clock stands in. The clock is the second choice because WebKit advances it once a
     frame: on a rendered track it read 0.12px behind the computed value on the seals, where Blink's two agree. */
  function stands(u) {
    var m = /matrix(3d)?\(([^)]+)\)/.exec(getComputedStyle(u.track).transform || ''), t;
    if (m) return -parseFloat(m[2].split(',')[m[1] ? 12 : 4]);
    t = u.anim.currentTime;
    return u.t + (typeof t === 'number' ? t / (u.secs * 1000) % 1 * u.period : 0);
  }
  /* The keyframes start at the transform the track already carries, so the roll begins where the belt stands
     whenever the compositor picks it up, and loop one period on, where the picture is the same. */
  function roll(u) {
    u.t = (u.t % u.period + u.period) % u.period; put(u);
    u.anim = u.track.animate([{ transform: shift(u.t) }, { transform: shift(u.t + u.period) }],
      { duration: u.secs * 1000, iterations: Infinity, easing: 'linear' });
    u.rolling = true;
  }
  function freeze(u) {
    u.t = snap(stands(u)); put(u);
    u.anim.cancel(); u.anim = null; u.rolling = false;
  }
  /* The visitor's swipe leaves the scroller wherever it stopped. Before the roll takes the belt back the scroller
     steps by whole periods to the middle of its range, so the next swipe has as much room one way as the other.
     scrollLeft may land on a whole pixel short of a fractional period; the transform takes the remainder. */
  function centre(u) {
    var s = u.scroller.scrollLeft, k = Math.round(((u.scroller.scrollWidth - u.view) / 2 - s) / u.period);
    if (!k) return;
    u.scroller.scrollLeft = s + k * u.period; u.sl = u.scroller.scrollLeft;
    u.t += s + k * u.period - u.sl;
  }
  /* the one place the roll starts and stops: every event sets its flag and calls this */
  function sync(u) {
    var go = u.on && u.seen && !u.holding && !u.settle && u.period > 0;
    if (go && !u.rolling) { centre(u); roll(u); }
    else if (!go && u.rolling) freeze(u);
  }
  function rest(u) {
    clearTimeout(u.settle);
    u.settle = setTimeout(function () { u.settle = 0; sync(u); }, REST);
  }
  /* A lazy picture starts loading when the main thread notices it near the screen. The roll now carries pictures
     there on the compositor, and whether every browser notices in time is not left to chance (it was not tested):
     the first time a belt is seen, its pictures are told to load. The copies share the first set's files, so
     this fetches nothing the roll would not have reached within a lap. */
  function feed(u) {
    if (u.fed) return; u.fed = true;
    [].forEach.call(u.track.querySelectorAll('img[loading="lazy"]'), function (i) { i.setAttribute('loading', 'eager'); });
  }

  function build(u) {
    u.scroller = document.createElement('div'); u.scroller.className = 'mq__scroll';
    u.sizer = document.createElement('div'); u.sizer.className = 'mq__size';
    u.parent.insertBefore(u.scroller, u.track); u.scroller.appendChild(u.sizer); u.sizer.appendChild(u.track);
    u.scroller.addEventListener('pointerdown', function () { u.holding = true; sync(u); }, { passive: true });
    u.scroller.addEventListener('pointerup', function () { u.holding = false; sync(u); }, { passive: true });
    /* pointercancel is the browser taking the touch for a scroll, with the finger still down and the first scroll
       event still to come: the roll waits out REST instead of starting under the swipe */
    u.scroller.addEventListener('pointercancel', function () { u.holding = false; if (u.on) rest(u); }, { passive: true });
    /* a mouse can be let go outside the belt, and the belt would never hear it */
    u.scroller.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse' && u.holding) { u.holding = false; sync(u); } }, { passive: true });
    u.scroller.addEventListener('scroll', function () {
      var s = u.scroller.scrollLeft;
      if (!u.on || Math.abs(s - u.sl) < 0.5) return;   /* our own step of whole periods, echoing back */
      u.sl = s; rest(u); sync(u);                      /* the visitor, not us */
    }, { passive: true });
    if ('IntersectionObserver' in window) {
      u.seen = false;
      new IntersectionObserver(function (es) {
        u.seen = es[es.length - 1].isIntersecting;
        if (u.seen && u.on) { feed(u); refit(u); }
        sync(u);
      }).observe(u.parent);
    }
  }
  function start(u) {
    if (u.on) return; u.on = true;
    if (!u.scroller) build(u);
    u.parent.classList.add('mq-swipe');
    u.period = 0; refit(u);
    if (u.seen) feed(u);
    sync(u);
  }
  function stop(u) {
    if (!u.on) return; u.on = false;
    if (u.rolling) { u.anim.cancel(); u.anim = null; u.rolling = false; }
    clearTimeout(u.settle); u.settle = 0; u.holding = false; u.t = 0;
    u.track.style.transform = ''; u.sizer.style.width = ''; u.sizer.style.overflow = '';
    u.clones.forEach(function (c) { if (c.parentNode) c.parentNode.removeChild(c); }); u.clones = [];
    u.parent.classList.remove('mq-swipe'); u.scroller.scrollLeft = 0;
  }
  function apply() { units.forEach(mq.matches ? start : stop); }
  apply();
  if (mq.addEventListener) mq.addEventListener('change', apply); else mq.addListener(apply);

  /* A phone's address bar sliding away fires resize too and changes no width, so that one is left alone. */
  var wide = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth === wide) return; wide = window.innerWidth;
    units.forEach(function (u) { if (u.on) { refit(u); sync(u); } });
  });

  /* THE 2026-09-30 ENGINE, for a browser without element.animate. Unchanged: the scroller is rolled by writing
     scrollLeft from requestAnimationFrame, with four periods of content and no sizer. */
  function legacy(tracks, mq) {
    var units = tracks.map(function (track) {
      return {
        track: track, parent: track.parentElement, scroller: null, clones: [],
        on: false, raf: 0, pos: 0, last: 0, holding: false, settle: 0, period: 0, speed: 0, seen: true,
        n: [].filter.call(track.children, function (c) { return !c.hasAttribute('aria-hidden'); }).length || 1,
        secs: parseFloat(getComputedStyle(track).animationDuration) || 30
      };
    });

    function measure(u) {
      var k = u.track.children;
      u.period = k.length > u.n ? k[u.n].offsetLeft - k[0].offsetLeft : u.track.scrollWidth / 2;
      u.speed = u.period / u.secs;
    }
    function wrap(u) {
      if (u.pos >= u.period * 2) { u.pos -= u.period; u.scroller.scrollLeft = u.pos; }
      else if (u.pos < u.period * 0.5) { u.pos += u.period; u.scroller.scrollLeft = u.pos; }
    }
    function frame(u, t) {
      if (!u.on) return;
      u.raf = requestAnimationFrame(function (t2) { frame(u, t2); });
      var dt = u.last ? Math.min(0.05, (t - u.last) / 1000) : 0; u.last = t;
      if (u.holding || u.settle || !u.seen) return;
      u.pos += u.speed * dt; wrap(u); u.scroller.scrollLeft = u.pos;
    }
    function start(u) {
      if (u.on) return; u.on = true;
      if (!u.scroller) {
        u.scroller = document.createElement('div'); u.scroller.className = 'mq__scroll';
        u.parent.insertBefore(u.scroller, u.track); u.scroller.appendChild(u.track);
        u.scroller.addEventListener('pointerdown', function () { u.holding = true; }, { passive: true });
        ['pointerup', 'pointercancel'].forEach(function (e) {
          u.scroller.addEventListener(e, function () { u.holding = false; u.pos = u.scroller.scrollLeft; }, { passive: true });
        });
        u.scroller.addEventListener('scroll', function () {
          if (!u.on) return;
          if (u.holding || Math.abs(u.scroller.scrollLeft - u.pos) > 2) {   /* the visitor, not us */
            u.pos = u.scroller.scrollLeft;
            clearTimeout(u.settle); u.settle = setTimeout(function () { u.settle = 0; wrap(u); }, REST);
          }
        }, { passive: true });
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (es) { es.forEach(function (e) { u.seen = e.isIntersecting; }); }).observe(u.parent);
        }
      }
      /* at least four periods of content, so the wrap band has room either side */
      var kids = [].slice.call(u.track.children), periods = kids.length / u.n;
      while (periods < 4) {
        kids.forEach(function (c) { var k = c.cloneNode(true); k.setAttribute('aria-hidden', 'true'); u.track.appendChild(k); u.clones.push(k); });
        kids = [].slice.call(u.track.children); periods = kids.length / u.n;
      }
      u.parent.classList.add('mq-swipe'); measure(u); u.pos = u.period; u.scroller.scrollLeft = u.pos; u.last = 0;
      u.raf = requestAnimationFrame(function (t) { frame(u, t); });
    }
    function stop(u) {
      if (!u.on) return; u.on = false; cancelAnimationFrame(u.raf);
      u.clones.forEach(function (c) { if (c.parentNode) c.parentNode.removeChild(c); }); u.clones = [];
      u.parent.classList.remove('mq-swipe'); u.scroller.scrollLeft = 0;
    }
    function apply() { units.forEach(mq.matches ? start : stop); }
    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply); else mq.addListener(apply);
    window.addEventListener('resize', function () {
      units.forEach(function (u) { if (u.on && u.period) { var f = u.pos / u.period; measure(u); u.pos = f * u.period; u.scroller.scrollLeft = u.pos; } });
    });
  }
})();
